// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2UP0K","rootSuccess":"CompleteLink_rootSuccess__1LH8g","rootFailure":"CompleteLink_rootFailure__2z9tb","isDisabled":"CompleteLink_isDisabled__3VEio"};